import ResponsiveHelper from "../utils/ResponsiveHelper";
import Swiper from "swiper/bundle";

export default class About {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initResponsiveHelper();
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
    });
  }

  resize() {
    // console.log("resize from Homepage.js");
  }
}
